import { render, staticRenderFns } from "./heatmapchart.vue?vue&type=template&id=183e5afc&"
import script from "./heatmapchart.vue?vue&type=script&lang=js&"
export * from "./heatmapchart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports